import { GzPatchManagementGeneralWebComponent } from './component/GzPatchManagementGeneralWebComponent';

export { GzPatchManagementGeneralWebComponent };
